import { Component, EventEmitter, Input, Output, Type, ViewChild, ViewContainerRef, ComponentRef, OnInit, AfterViewInit } from '@angular/core';

@Component({
    selector: 'app-drawer',
    template: `
        <div class="overlay" (click)="close()"></div>
        <div class="drawer" [ngClass]="side" [ngStyle]="{ width: width }">
            <div class="drawer-body">
                <ng-template #container></ng-template>
            </div>
        </div>
    `,
    styles: [
        `
            .overlay {
                position: fixed;
                top: 0;
                left: 0;
                width: 100vw;
                height: 100vh;
                background: rgba(0, 0, 0, 0.5);
                z-index: 500;
            }
            .drawer {
                position: fixed;
                top: 0;
                bottom: 0;
                background: white;
                z-index: 501;
                display: flex;
                flex-direction: column;
            }
            .drawer-header {
                flex: 0 0 auto;
                padding: 1rem;
                border-bottom: 1px solid #ddd;
            }

            .drawer-body {
                flex: 1 1 auto;
                overflow-y: auto;
            }

            .drawer.right {
                right: 0;
                transform: translateX(0);
            }
            .drawer.left {
                left: 0;
                transform: translateX(0);
            }

            @media (max-width: 768px) {
                .drawer {
                    width: 100vw !important;
                }
            }
        `,
    ],
})
export class DrawerComponent implements AfterViewInit {
    @Input() side: 'left' | 'right' = 'right';
    @Input() childComponentType!: Type<any>;
    @Input() componentData: any = {};
    @Input() width: string = '80vw'; // default if not provided

    @Output() closed = new EventEmitter<void>();
    @ViewChild('container', { read: ViewContainerRef, static: true }) container!: ViewContainerRef;

    private childComponentRef!: ComponentRef<any>;

    ngAfterViewInit(): void {
        this.container.clear();
        this.childComponentRef = this.container.createComponent(this.childComponentType);
        Object.assign(this.childComponentRef.instance, this.componentData);
    }

    public close(): void {
        this.closed.emit();
    }
}
